import { render, staticRenderFns } from "./PFormInputTextSearch.vue?vue&type=template&id=3e57f2e8&scoped=true"
import script from "./PFormInputTextSearch.vue?vue&type=script&lang=ts"
export * from "./PFormInputTextSearch.vue?vue&type=script&lang=ts"
import style0 from "./PFormInputTextSearch.vue?vue&type=style&index=0&id=3e57f2e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e57f2e8",
  null
  
)

export default component.exports